import React from 'react'
import { WithTranslation } from 'react-i18next'
import { Form, PasswordInput } from '../../../components/FormBuilder'
import { IWithSize } from '../../BookingCalendar/Calendar/Calendar'

function ChangePassword({
  t,
  click,
  size = 1,
}: WithTranslation & IChangePassword & IWithSize) {
  function onSubmit() {
    return
  }

  return (
    <Form onSubmit={onSubmit}>
      <PasswordInput.ReduxField
        size={size}
        onFocus={click}
        label={t('BBO_936_old_password')}
        name={'oldPassword'}
        style={{ lineHeight: `${38 * size}px`, maxHeight: `${38 * size}px` }}
      />
      <PasswordInput.ReduxField
        size={size}
        onFocus={click}
        label={t('BBO_936_new_password')}
        name={'newPassword'}
        style={{ lineHeight: `${38 * size}px`, maxHeight: `${38 * size}px` }}
      />
      <PasswordInput.ReduxField
        size={size}
        onFocus={click}
        label={t('BBO_936_repeat_new_password')}
        name={'newPasswordAgain'}
        style={{ lineHeight: `${38 * size}px`, maxHeight: `${38 * size}px` }}
      />
    </Form>
  )
}

export default ChangePassword

export interface IChangePassword {
  click?: () => void
}
